<template>
	<div>
		<div v-if="show" >
			<div v-for="group in groups">
				<h5>{{ group.name }}</h5>
				<div v-for="field in group.fields">
					<div class="row">
			            <div class="col-auto">
			            	<label class="mw-80">
			            		<strong>{{ field.form_name }}</strong>
			            	</label>
			            </div>
			            <div class="col-auto flex-fill">
				            <v-select :options="field.tags" multiple 
				            	v-model="field.selected"></v-select>
					    </div>
		            </div> 
				</div>
			</div>
			<br />
		</div>
	</div>
</template>

<script>
	export default{
		props : {
			entity_str : {
				type : String, //i.e App\Models\Course
				required : false
			},
			entity : {
				type : Object, //the object with the fields
				required : false
			}		
		},
		data : function(){
			return {
				show : false,
				groups : null,
				tag : ''
			}
		},

		created : function(){
			this.getEntity();
		},


		watch: { 
	      	entity: function(newVal, oldVal) { // watch it
	          this.getEntity();
	        }
      	},

		methods : {
			getEntityName : function(){
				return this.entity_str
			},
			getEntity : function(){
				var params = {
					filters : {
						name : this.getEntityName(),
						page_loading : false
					}
				}

				this.$store.dispatch('getEntitiesTaggables', params).then((res) => {
					
					this.groups = null;

					//if we have the entity is because we are in edit mode
					if(this.entity){
						var group_aux = res.data.data.groups;
						for(var i in group_aux){
							for(var j in group_aux[i].fields){
								group_aux[i].fields[j].selected = [];
								//search if this field has tags
								for(var k in this.entity.tags){
									if(this.entity.tags[k].fmap_id == group_aux[i].fields[j].id){
										group_aux[i].fields[j].selected.push(this.entity.tags[k].tag);
									}
								}
							}
						}

						this.groups = group_aux;

					}else{
						this.groups = res.data.data.groups;
					}	

					this.show = true;				
				}).catch((error) => {
					console.log(error);
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/shared/TagComponent.vue